import { apiClient } from "api/trpc/trpc-client"
import { messageError } from "reusable/mui/modals/message-error"
import * as Sentry from '@sentry/browser'
import { UserDto } from "@gap/backend/app-services/user/models/UserDto"
import SSOAnalytics, { SSOAnalyticsTypes } from "analytics/SSOAnalytics"

export const handleCircleSSO = async (userData: UserDto.info, initiatedFrom: SSOAnalyticsTypes.InitiatedFrom) => {
   try {
      SSOAnalytics.onGapAcademyAccessed({ "Initiated from": initiatedFrom })

      if (!userData.circleId) {
         await messageError('Gap Academy Access', 'Your account is not yet set up for Gap Academy. Please contact support.')
         return
      }

      const circleUrl = await apiClient.oAuthClient.generateCircleLoginUrl.query()
      window.open(circleUrl, '_blank')
   } catch (error) {
      Sentry.captureException(error, { tags: { component: 'MenuStore', action: 'circle-sso' } })
      await messageError('Gap Academy Error', 'Unable to access Gap Academy. Please try again or contact support.')
   }
}